import {Injectable} from '@angular/core';
import {RequestExecutor} from '../util/request-executor';
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';

@Injectable()
export class LoginService {
  constructor(
    private request: RequestExecutor) {
  }

  login(parameters: any): Promise<any> {
    return this.request.post('/session/login', parameters);
  }

  getDepartments() {
    return this.request.get('/departments');
  }

  getCarriers() {
    return this.request.get('/carriers');
  }
}
